import { render } from "./StudentTileShimmer.vue?vue&type=template&id=0e79c71e"
import script from "./StudentTileShimmer.vue?vue&type=script&lang=js"
export * from "./StudentTileShimmer.vue?vue&type=script&lang=js"
script.render = render

export default script